import React from "react";
import BottomSheet from "../../../components/ui/BottomSheet";
import SheetHeader from "../../../components/ui/SheetHeader";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/ui/Icon";
import { IStore, IDistrict, IDistance } from "../../../classes/interfaces";
import { formatBRL } from "../../../helpers/currency.helper";
import { useIsDesktopViewport } from "../../../hooks/useIsDesktopViewport";
import {
  Body,
  RatesCard,
  RateRow,
  RateIconBadge,
  RateTexts,
  RateName,
  RateHint,
  RatePrice,
  Footer,
} from "./TaxasModal.styles";

interface TaxasModalProps {
  isOpen: boolean;
  company: IStore;
  onClose: () => void;
}

export default function TaxasModal({ isOpen, company, onClose }: TaxasModalProps) {
  const desktop = useIsDesktopViewport();
  const byDistrict = company.districts && company.districts.length > 0;

  return (
    <BottomSheet open={isOpen} onClose={onClose} maxHeight="86%" centered={desktop}>
      <SheetHeader
        title="Taxas de entrega"
        sub={byDistrict ? "Valor conforme o seu bairro" : "Valor conforme a distância"}
        onClose={onClose}
      />
      <Body>
        <RatesCard>
          {byDistrict
            ? company.districts.map((district: IDistrict) => (
                <RateRow key={district.id}>
                  <RateIconBadge>
                    <Icon name="moto" size={17} />
                  </RateIconBadge>
                  <RateTexts>
                    <RateName>{district.name}</RateName>
                  </RateTexts>
                  <RatePrice>{formatBRL(district.tax)}</RatePrice>
                </RateRow>
              ))
            : company.distances.map((distance: IDistance) => (
                <RateRow key={distance.id}>
                  <RateIconBadge>
                    <Icon name="moto" size={17} />
                  </RateIconBadge>
                  <RateTexts>
                    <RateName>{distance.name}</RateName>
                    <RateHint>
                      {`${(distance.initial / 1000).toFixed(0)} a ${(distance.final / 1000).toFixed(0)} km`}
                    </RateHint>
                  </RateTexts>
                  <RatePrice>{formatBRL(distance.value)}</RatePrice>
                </RateRow>
              ))}
        </RatesCard>
      </Body>
      <Footer>
        <Button variant="primary" size="lg" full onClick={onClose}>
          Entendi
        </Button>
      </Footer>
    </BottomSheet>
  );
}
